export default __webpack_public_path__ + "static/briefing-62e11b003aca97948507279b066404ff.png";